import { DatePicker, Input } from 'antd'
import React, { useMemo, useState } from 'react'
import { FilterOptionsTypesEnum } from 'enum/filterType.enum'
import { IFilterOption } from 'interfaces/filterProps'
import OptionFilterSelect from '../../select'
import en_US from 'antd/es/locale/en_US'
import moment from 'moment'
import styles from './index.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt'
import { es_dateFormat } from 'constants/date'
import { operatorsList, operatorsStringPart, specialOperators } from 'constants/operators'
import AsyncOptionFilterSelect from '../../async-select'

interface IGetCompareToInput {
  translations: any
  compareToData: any
  selectedData: any
  onChange: any
  operatorData: any
  inputData?: any
  inputOptions?: IFilterOption[]
  className?: string
  dateFormat?: string
  dataTest?: string
}

const GetCompateToInput: React.FC<IGetCompareToInput> = ({
  translations,
  inputData,
  inputOptions = [],
  operatorData,
  onChange,
  compareToData,
  selectedData,
  className = '',
  dateFormat = es_dateFormat,
  dataTest,
}) => {
  const [inputValue, setInputValue] = useState(compareToData?.value || '')

  const { list, tagsList, string, number, date, hybrid, group } = FilterOptionsTypesEnum
  const {
    data: { value: inputDataValue, min = 0, max },
    type,
    onSearch,
    async,
  } = inputData

  const auxType = type === date && !['eq', 'lt', 'gt'].includes(operatorData.value) ? number : type

  useMemo(() => setInputValue(compareToData?.value || ''), [compareToData?.value])

  const handleSearch = async (value: string) => onSearch && onSearch(value)

  let content = <OptionFilterSelect disabled className={className} options={[] as IFilterOption[]} selectedOption={undefined} translations={translations} onChange={() => {}} />

  if (operatorData && operatorData.value && !operatorData.value.includes('null')) {
    // LIST / TAGLIST / HYBRID / GROUP
    if (
      ((auxType === list || auxType === tagsList) && operatorData.value.includes('eq')) ||
      ((operatorsList.includes(operatorData.value) || specialOperators.includes(operatorData.value)) && auxType === hybrid) ||
      auxType === group
    ) {
      let options = [] as IFilterOption[]
      const exist = inputOptions.find(({ value }) => value === inputDataValue)
      options = (exist && exist.list) || options

      if (async) {
        content = (
          <AsyncOptionFilterSelect
            className={className}
            dataTest={dataTest}
            selectedOption={selectedData}
            tags={auxType === tagsList}
            translations={translations}
            onChange={onChange}
            onSearch={handleSearch}
          />
        )
      } else {
        content = (
          <OptionFilterSelect
            className={className}
            dataTest={dataTest}
            options={options}
            selectedOption={compareToData}
            tags={auxType === tagsList}
            translations={translations}
            onChange={onChange}
            onSearch={onSearch}
          />
        )
      }
    }
    if (auxType === string || auxType === number || (operatorsStringPart.includes(operatorData.value) && auxType === hybrid))
      content = (
        <Input
          className={`${className} ${auxType === number ? styles.inputWidthSuffix : ''}`}
          data-testid={dataTest}
          max={max}
          min={min}
          suffix={type === date && auxType === number && 'días'}
          type={auxType}
          value={inputValue}
          onChange={(e: any) => {
            setInputValue(e.target.value)
            onChange({ value: e.target.value })
          }}
        />
      )

    if (auxType === date)
      content = (
        <DatePicker
          className={className}
          data-testid={dataTest}
          format={dateFormat}
          locale={{ ...en_US.DatePicker, lang: { ...en_US.DatePicker.lang, today: translations.today } }}
          placeholder=""
          suffixIcon={<FontAwesomeIcon className={styles.calendarIcon} icon={faCalendarAlt} />}
          value={inputValue ? moment(new Date(inputValue), dateFormat) : null}
          onChange={(date: any) => {
            const newValue = (date && moment(date).toISOString()) || undefined
            setInputValue(newValue)
            onChange({ value: newValue })
          }}
        />
      )
  }

  return content
}
export default GetCompateToInput
